var render, staticRenderFns
import script from "./detail_table.vue?vue&type=script&lang=js"
export * from "./detail_table.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/jenkins/workspace/web-page/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('34fa8944')) {
      api.createRecord('34fa8944', component.options)
    } else {
      api.reload('34fa8944', component.options)
    }
    
  }
}
component.options.__file = "found/views/tpm/views/budget/dealer_fine_records/components/detail_table.vue"
export default component.exports